// Keep unrelated filters, tracking parameters, and anchors intact.
export function readHubId(parameter) {
  const value = new URL(window.location.href).searchParams.get(parameter);
  return value && /^[1-9][0-9]*$/.test(value) ? value : null;
}

export function writeHubId(parameter, id, replace = false) {
  const url = new URL(window.location.href);
  if (id) {
    url.searchParams.set(parameter, id);
  } else {
    url.searchParams.delete(parameter);
  }
  if (parameter === 'insight' && /^#energy-insight-/.test(url.hash)) {
    url.hash = '';
  }
  if (url.href !== window.location.href) {
    window.history[replace ? 'replaceState' : 'pushState'](
      window.history.state, '', url.href
    );
  }
}
